export default "__VITE_ASSET__BOJV9PqG__"